(function(jQuery) {

  function isInView(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
  }
  
  function isElemInView(el) {
    var rect = el.getBoundingClientRect();
    
    return rect.top - $(window).height() <= 0;
  }

  function iib() {
    var $this = $(this),
        $images = $this.find('.iib__img'),
        $imageContainer = $this.find('.iib__image-container'),
        $textContainers = $this.find('.iib__text-container'),
        $prev = $this.find('.iib__btn--prev'),
        $next = $this.find('.iib__btn--next'),
        active = 1;    
    
    function setActive() {      
      $images.removeClass('iib__img--active');
      $this.find('.iib__img' + active).addClass('iib__img--active');
      
      $textContainers.removeClass('iib__text-container--active');
              $this.find('.iib-text').removeClass('bg--light-magenta bg--mid-magenta bg--purple bg--dark-teal bg--orange').addClass($this.find('.iib__text-container' + active).data('bg'));
      
      setTimeout(function(){
      	$this.find('.iib__text-container' + active).addClass('iib__text-container--active');
      }, 300);
      

      setTimeout(function(){
        $imageContainer.removeClass('iib__image-container--active');
      }, 100);      
    }
    
    $next.on('click', function(){
      if(active + 1 <= 3){
        active+=1;
        $imageContainer.addClass('iib__image-container--active');
        setActive();
      }
      
    });
    
     $prev.on('click', function(){
      if(active - 1 >= 1){
      	active-=1;
        $imageContainer.addClass('iib__image-container--active');
        setActive();
      }
       
    });
  }
  
  function stats() {
      var observer,
          config = { attributes: true };

      function callback(mutationsList, observer) {
        
        for(var mutation in mutationsList) {
          var thisMutation = mutationsList[mutation];
          
          if (thisMutation.attributeName === 'class') {

            $(thisMutation.target).find('.stats__number').each(function() {
              $(this).find('.odometer').html($(this).data('stat').toString());
            });
          }
        }
      }

      observer = new MutationObserver(callback);

      function Statistics(){
        $('.stats').each(function(){
          observer.observe($(this)[0], config);
        });      
      }

      Statistics();
    
    $('.stats').each(function(){
      var $stat = $(this);
      
      if(isElemInView($stat[0])) {
        $stat.addClass('in-view');
      }
      
      $(window).on('scroll', function(){

        if(isElemInView($stat[0])) {
        	$stat.addClass('in-view');
        }
      });
    });     
  }
  
  function gallery() {
  	var $this = $(this),
        $imageContainer1 = $this.find('.image-gallery--image1'),
        $images1 = $imageContainer1.find('.image-gallery__img'),
        imagesLength1 = $images1.length,
        active1 = 0,
        $imageContainer2 = $this.find('.image-gallery--image2'),
        $images2 = $imageContainer2.find('.image-gallery__img'),
        imagesLength2 = $images2.length,
        active2 = 0;
    
    $this.find('.image-gallery__image').each(function(){
    	$(this).find('.image-gallery__img').first().addClass('image-gallery__img--active');
    });
    
    function setActive() {
      	$images1.removeClass('image-gallery__img--active');      
      	$images1.eq(active1).addClass('image-gallery__img--active');
      
        $images2.removeClass('image-gallery__img--active');      
        $images2.eq(active2).addClass('image-gallery__img--active');
      
      	$imageContainer1.addClass('image-gallery__image--active');
      	$imageContainer2.addClass('image-gallery__image--active');
      
        setTimeout(function(){
          $imageContainer1.removeClass('image-gallery__image--active');
          $imageContainer2.removeClass('image-gallery__image--active');
        }, 100);
    }
    
    $this.find('.image-gallery__prev').on('click', function(){
      
        if(active1 - 1 < 0) {
          active1 = imagesLength1 - 1;
        } else {
          active1-=1; 
        }

        if(active2 - 1 < 0) {
          active2 = imagesLength2 - 1;
        } else {
          active2-=1; 
        }
      
      	setActive();
    });
    
    $this.find('.image-gallery__next').on('click', function(){

      if(active1 + 1 >= imagesLength1) {
        active1 = 0;
      } else {
        active1+=1; 
      }
      
      if(active2 + 1 >= imagesLength2) {
      	active2 = 0;
      } else {
      	active2+=1; 
      }

      setActive();
    });
  }
  
  function penrose(){
      var $section = $(this);
            
      $section.find('.accent').on({
        mouseenter: function() {
          if($(this).hasClass('inactive')) {
           return; 
          }
             
          $(this).closest('svg').find('g').not($(this)).addClass('opacity');
          $(this).removeClass('opacity');
        },
        click: function() {
          var card = '.' + $(this).data('section');
          
          if($(this).hasClass('active') || !$section.find(card).length) {
           return; 
          }          
          
          $(this).closest('svg').find('g').not($(this)).addClass('inactive').removeClass('active');
          $(this).addClass('active').removeClass('inactive');
          
          $section.find('.penrose-card').hide();                    
          $section.find('.penrose__intro').hide();
          $section.find(card).stop().fadeIn();
        },
        mouseleave: function() {
          $(this).closest('svg').find('g').not($(this)).removeClass('opacity');          
        }
      });
      
      $section.find('.penrose__close').on('click', function(){
        $section.find('svg').find('g').removeClass('inactive active');
      	$section.find('.penrose-card').hide();
        $section.find('.penrose__intro').stop().fadeIn();
      });
      
      $section.find('.penrose__select').on('change', function(){
      	var card = '.' + $(this).val();
        
        if(!$section.find(card).length) {
          $section.find('.penrose-card').hide();
          $section.find('.penrose__intro').stop().fadeIn();
          return;
        }
        
        $section.find('.penrose-card').hide();                    
        $section.find('.penrose__intro').hide();
        $section.find(card).stop().fadeIn();
      });
    }
  
  function fadeInView() {
  	var $this = $(this);
    
    $(window).on('scroll', function(){

        if(isElemInView($this[0])) {
        	$this.addClass('in-view');
        }
      });
  }

  function rteGallery() {
    var $this = $(this);
    var modal = '<div class="rte-gallery-modal"><div class="rte-gallery-modal__inner"></div><div class="rte-gallery-modal__wrapper"><button class="rte-gallery-modal__close"></button></div></div>';
    
    $('body').append(modal);
    
    $this.find('img').on('click', function(){
      var $thisImg = $(this);
      var $modal = $('.rte-gallery-modal');
      var $modalInner = $('.rte-gallery-modal__inner');
      
      $modalInner.html($thisImg.clone());
      $modal.fadeIn();
    });
    
    $('body').on('click', '.rte-gallery-modal__close', function(){
      var $modal = $('.rte-gallery-modal');
      
      $modal.fadeOut();
    });
  }

  function announcement() {
    var $this = $(this);
    var loadScrollTop = $(window).scrollTop();
   
    
    
    }

  
  $(document).ready(function(){
    $('.iib').each(iib);
    $('.image-gallery').each(gallery);
    $('.penrose-animation').each(penrose);
    $('.fade-comp').each(fadeInView);
    $('.rte-gallery').each(rteGallery);
    $('.announcement').each(announcement);
    console.log($('.announcement'));
    console.log('document ready');
    
    if ($('.stats').length){
      stats();
    }

  });

})(jQuery)